import React from 'react';
import { LocalizedMessage, LocalizedStandardDate } from 'intl/LocalizedComponents';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import queryString from 'query-string';
// Models
import mAccessWay from 'models/accessWay';
import mInstallationLog from 'models/installationLog';
import mListParam from 'models/listParam';
// Permissions
import OnlyWith from 'components/permissions/OnlyWith';
import permissions from 'constants/Permissions';
// Custom
import { customerDataShape } from 'constants/PropTypesShapes';
import { logsPath } from 'installations/navigation';
import withPermissions from 'hocs/WithPermissions';
import RowDetailsTemplate from 'components/templates/RowDetailsTemplate';
import Callout from 'components/misc/Callout';
import { AccessesTextButton, OperationsHistoryTextButton } from 'components/buttons/TextButtons';
import CustomerAccessWayItem from './CustomerAccessWayItem';
import CustomerStateForm from './CustomerStateForm';

// Get the path to customer logs
const getLogsPath = (id, idCustomer) => {
  // Get filter from model
  const { type, filter } = _find(mInstallationLog.listFeatures.searchFields, ['key', 'installationCustomer']);
  // Build filters to apply
  const filters = [{ field: filter.field, operator: type.defaultOperator(), value: idCustomer }];
  return `${logsPath(id)}?${queryString.stringify({ filters: mListParam.filters.serialize(filters) })}`;
};

const CustomerRowDetails = ({
  hasPermission, id, customer,
  onDisplaySyncHistory, onTriggerRight, onUpdateState, onReinitState,
}) => {
  if (customer) {
    const sortedAccessWays = mAccessWay.sortElements(customer.access_ways);

    // Specific permsissions
    const { pInstallation: { configRead, customerWrite } } = permissions;

    return (
      <RowDetailsTemplate
        buttons={[
          <OnlyWith
            key="bLogs"
            permissions={{
              needed: configRead,
              permissionsOrContext: 'installationPermissions',
            }}
          >
            <AccessesTextButton primary path={getLogsPath(id, customer.id)} />
          </OnlyWith>,
          <OperationsHistoryTextButton primary onClick={() => onDisplaySyncHistory(customer)} key="bSyncHist" />,
        ]}
      >
        <div className="px-3 pb-3">
          <div className="row">
            <div className="col-12">
              <Callout>
                <LocalizedMessage id="title.accessWays" />
              </Callout>
            </div>
            {!!sortedAccessWays
              && _map(sortedAccessWays, (accessWay) => (
                <div key={_toString(accessWay.id)} className="col-xl-4 col-md-6 col-sm-12">
                  <CustomerAccessWayItem
                    accessWay={accessWay}
                    displayRights={hasPermission({ needed: configRead, permissionsOrContext: 'installationPermissions' })}
                    initiallyOpen
                    permissions={{
                      needed: customerWrite,
                      permissionsOrContext: 'installationPermissions',
                    }}
                    rightAction={{
                      permissions: `${configRead}&&${customerWrite}`,
                      desc: {
                        type: 'button_trigger',
                        cb: (right) => onTriggerRight(customer, accessWay, right),
                      },
                    }}
                  />
                </div>
              ))}
            {_isEmpty(sortedAccessWays) && (
              <div className="col-12 pt-3">
                <LocalizedMessage id="info.noAccessWay" />
              </div>
            )}
            <div className="col-12 pt-3">
              <Callout>
                <LocalizedMessage
                  id="title.stateWeight"
                  values={{
                    date: <LocalizedStandardDate value={customer.state.date} />,
                    weight: customer.weight,
                  }}
                />
              </Callout>
            </div>
            <div className="col-12 col-lg-6 pt-3">
              <CustomerStateForm customer={customer} onUpdate={onUpdateState} onReinit={onReinitState} />
            </div>
          </div>
        </div>
      </RowDetailsTemplate>
    );
  }
  return null;
};

CustomerRowDetails.propTypes = {
  hasPermission: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  customer: customerDataShape,
  onDisplaySyncHistory: PropTypes.func.isRequired,
  onTriggerRight: PropTypes.func.isRequired,
  onUpdateState: PropTypes.func.isRequired,
  onReinitState: PropTypes.func.isRequired,
};

CustomerRowDetails.defaultProps = {
  customer: null,
};

module.exports = withPermissions(CustomerRowDetails);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/customers/CustomerRowDetails.js